import React, { useState, useEffect } from "react";
import axios from "axios";
import { CheckToken } from "../login/AccessToken";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import "./BillingPayment.scss";
import { Card } from "@mui/material";
import SideNavbar from "./SideNavbar";

// import Icon from "../doctor-console/Utils/Icons";
import { ReactComponent as CalendarIcon } from './DummyIcons/calendar-silhouette 2.svg';

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import {
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Radio, RadioGroup } from "@mui/material";
import { displayPatientName } from "../../utils/displayPatientName";

const EditEstimate = () => {
  const [itemsList, setItemsList] = useState([
    { items: "", quantity: "", price: "", amount: "", category: "services" },
  ]);
  const [subtotal, setSubtotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [tax, setTax] = useState(0);
  const [notes, setNotes] = useState("");
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const [selectedPatientName, setSelectedPatientName] = useState("");
  const [finalTotal, setFinalTotal] = useState("");
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [patientList, setPatientList] = useState([]);
  const [services, setServices] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [selectedCategory, setSelectedCategory] = useState("services");

  const [servicesList, setServicesList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const history = useHistory();
  const location = useLocation();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    if (authToken && servicesList.length > 0 && productsList.length > 0) {
      const { data } = location.state || {};
      if (data) {
        const initialItemsList = data.items.map((item) => {
          const category =
            item.item_type === "Medical Service" ? "services" : "products";
          const matchedItem =
            (category === "services"
              ? servicesList.find(
                (service) => service.medical_service_id === item.item_id
              )
              : productsList.find(
                (product) => product.product_id === item.item_id
              )) || {};

          return {
            items: item.item_id,
            quantity: item.quantity,
            price: matchedItem.fee?.toFixed(2) || item.item_price.toFixed(2),
            amount: item.subtotal.toFixed(2),
            category,
          };
        });
        setItemsList(initialItemsList);
      }
    }
  }, [location.state, servicesList, productsList, authToken]);

  useEffect(() => {
    // Extract data from location state and set initial values for form fields
    const { data } = location.state || {};
    console.log("Extracted data:", data);
    if (data) {
      // Set initial values based on data
      const {
        estimate_id,
        estimate_date,
        expiry_date,
        estimate_number,
        items,
        total_amount,
        discount,
        note,
        patient_id,
        name,
      } = data;
      // const initialItemsList = items.map((item) => ({
      //   items: item.item_id,
      //   quantity: item.quantity,
      //   price: item.subtotal / item.quantity, // assuming quantity is not 0
      //   amount: item.subtotal,
      // }));

      const initialItemsList = items.map((item) => {
        const matchedService = servicesList.find(s => s.medical_service_id === item.item_id) || {};
        const isService = (item.item_type === "Medical Service" || !item.item_type);
        return {
          items: item.item_id,
          quantity: item.quantity,
          price: (item.subtotal / item.quantity).toFixed(2), // Calculated price
          amount: item.subtotal.toFixed(2),
          category: item.item_type || "services", // Default category
        };
      });

      console.log("initialItemsList", initialItemsList);
      setItemsList(initialItemsList);

      setItemsList(initialItemsList);
      setSubtotal(data.subtotal || 0);
      setDiscount(discount || 0);
      setTax(data.tax || 0);
      setNotes(note || "");
      setFinalTotal(total_amount);

      // Set other fields
      document.getElementById("totalAmount").value = total_amount || 0;
      document.getElementById("patientSelect").value = data.customer;
      document.getElementById("estimateDate").value = estimate_date;
      document.getElementById("expiryDate").value = expiry_date;
      document.getElementById("estimateNumber").value = estimate_number;
      document.getElementById("patientSelect").value = patient_id;

      // Set initial values for patient select dropdown
      setSelectedPatientId(patient_id);
      setSelectedPatientName(name);
      // Update other fields as needed
      // ...
    }
  }, [location.state]);

  useEffect(() => {
    const subtotal = itemsList.reduce(
      (acc, item) => acc + parseFloat(item.amount),
      0
    );

    const total = subtotal * (1 - discount / 100) * (1 + tax / 100);

    setCalculatedTotal(total.toFixed(2));
  }, [itemsList, discount, tax]);

  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data) {
            setPatientList(res.data?.data);
          } else {
            console.log("Error");
          }
        });

      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`, {
          headers: headers,
        })
        .then((res) => {
          if (res.data.status == "Success") {
            const filteredServices = res.data.service_list.filter(
              (service) => !service.expired && service.active
            );
            setServices(filteredServices);
          } else {
            console.log("Error");
          }
        });
    }
  }, [authToken]);
  console.log("testing..", services);

  const handleAddItem = () => {
    setItemsList([
      ...itemsList,
      { items: "", quantity: "", price: "", amount: "", category: "services" }, // Default category as "services"
    ]);
  };

  useEffect(() => {
    if (authToken !== "") {
      // Fetch services
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`, {
          headers,
        })
        .then((res) => {
          const filteredServices = res.data.service_list.filter(
            (service) => !service.expired && service.active
          );
          setServicesList(filteredServices);
        });

      // Fetch products
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`, {
          headers,
        })
        .then((res) => {
          const filteredProducts = res.data.product_list.filter(
            (product) => !product.expired && product.active
          );
          setProductsList(filteredProducts);
        });
    }
  }, [authToken]);

  const handleItemChange = (index, field, value) => {
    const updatedItemsList = [...itemsList];
    updatedItemsList[index][field] = value;

    if (field === "category") {
      updatedItemsList[index].category = value;
      updatedItemsList[index].items = "";
      updatedItemsList[index].price = "";
      updatedItemsList[index].amount = "";
    } else if (field === "items") {
      const selectedItems =
        updatedItemsList[index].category === "services"
          ? servicesList
          : productsList;
      const selectedItem = selectedItems.find(
        (item) => item.medical_service_id === value || item.product_id === value
      );
      if (selectedItem) {
        updatedItemsList[index].price = selectedItem.fee.toFixed(2);
        updatedItemsList[index].amount = (
          (parseFloat(updatedItemsList[index].quantity) || 0) * selectedItem.fee
        ).toFixed(2);
      } else {
        updatedItemsList[index].price = "";
        updatedItemsList[index].amount = "";
      }
    } else if (field === "quantity") {
      const price = parseFloat(updatedItemsList[index].price) || 0;
      const quantity = parseFloat(value) || 0;
      updatedItemsList[index].amount = (quantity * price).toFixed(2);
    }

    setItemsList(updatedItemsList);
  };

  const handleTotalChange = (field, value) => {
    if (field === "discount") {
      setDiscount(parseFloat(value) || 0);
    } else if (field === "tax") {
      setTax(parseFloat(value) || 0);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const filteredItems = itemsList.filter(
      (item) =>
        item.items &&
        item.quantity != null &&
        item.quantity != null &&
        item.quantity !== ""
    );

    // Check if any required item or quantity is not selected
    if (filteredItems.length !== itemsList.length) {
      console.log(filteredItems.length);
      console.log(itemsList.length);
      toast.error("Please select an item and enter the quantity for all rows.");
      return;
    }

    const tot = document.getElementById("totalAmount").value;
    // Validate total_amount
    if (isNaN(tot) || tot <= 0) {
      toast.error("Total amount must be a valid number greater than 0.");
      return;
    }
    // Retrieve values from form input fields
    const estimateDate = document.getElementById("estimateDate").value;
    const expiryDate = document.getElementById("expiryDate").value;
    const estimateNumber = document.getElementById("estimateNumber").value;

    // Create items array from itemsList state
    const items = itemsList.map((item) => ({
      item_id: item.items,
      quantity: parseInt(item.quantity, 10) || 0,
    }));

    // Create the data object
    const estimateData = {
      hip_id: facilityName,
      estimate_number: estimateNumber,
      total_amount: document.getElementById("totalAmount").value,
      estimate_date: estimateDate,
      expiry_date: expiryDate,
      patient_id: selectedPatientId,
      items: items,
      note: notes,
      discount: discount,
      tax: tax,
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}update_estimate/`,
        JSON.stringify(estimateData),
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log("Estimate submitted successfully:", response.data);
        if (response.data.status === "Success") {
          toast.success(response.data.message);
          setTimeout(() => {
            history.push("/doctor/estimates");
          }, 2000);
        } else {
          console.error("Error submitting estimate:", response.data.message);
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error submitting estimate:", error);
        // Handle errors (e.g., show error message to the user)
      });
    console.log("Submitted Data:", estimateData);
  };

  const handleRemoveItem = (indexToRemove) => {
    const updatedItemsList = itemsList.filter(
      (item, index) => index !== indexToRemove
    );
    setItemsList(updatedItemsList);
  };

  const handleNotesChange = (value) => {
    setNotes(value);
  };

  const handleGoBack = () => {
    history.push("/doctor/estimates");
  };
  return (
    <>
      <SideNavbar>
        <form onSubmit={handleSubmit}>
          {/* <Grid container>
          <Grid item xs={12} sm={12} md={6}>
            <div className="back-icon" onClick={handleGoBack}>
              <ArrowBackIcon />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}></Grid>
        </Grid> */}

          <Card
            sx={{
              // boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              padding: "5px 10px",
              margin: "5px 10px",
            }}
          >
            {/* <Grid container>
              <Grid item xs={12} sm={12} md={6}>
                <div className="back-icon" onClick={handleGoBack}>
                  <ArrowBackIcon />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6}></Grid>
            </Grid> */}
            <p style={{ fontWeight: "bold", fontSize: "32px", color: "#172935", marginBottom: "16px" }}>Cost Estimates</p>
            <Grid container spacing={4} style={{ alignItems: "flex-start" }}>
              {/* Patient Field (Left Side) */}
              <Grid item xs={12} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label htmlFor="patient" className="required-label">
                    Patient{" "}
                  </label>
                  <div className="form-group">
                    <select
                      className="form-control"
                      id="patientSelect"
                      name="patientSelect"
                      value={selectedPatientId}
                      onChange={(e) => {
                        const id = e.target.value;
                        setSelectedPatientId(id);
                        const p = patientList.find(
                          (x) => String(x.patient_id) === String(id)
                        );
                        setSelectedPatientName(p?.name ?? "");
                      }}
                    >
                      {patientList.map((patient) => (
                        <option
                          key={patient.patient_id}
                          value={patient.patient_id}
                        >
                          {displayPatientName(patient.name)}
                        </option>
                      ))}
                    </select>
                  </div>
                </Grid>
              </Grid>

              {/* Right Side (Other Fields) */}
              <Grid item xs={12} sm={6} md={6}>
                <Grid container spacing={2}>
                  {/* Estimate Date */}
                  <Grid item xs={12} sm={6} md={6}>
                    <div className="input-wrapper">
                      <label htmlFor="estimateDate" className="required-label">
                        Estimate Date{" "}
                      </label>
                      <div className="date-input-container" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          className="form-control date-input"
                          id="estimateDate"
                          name="estimateDate"
                          required
                          readOnly
                          max="2050-01-01"
                          style={{ paddingRight: '2.5rem' }}
                        />
                        <i
                          style={{
                            position: 'absolute',
                            right: '0.75rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                          }}
                        >
                          <CalendarIcon
                            onClick={() =>
                              document.getElementById("estimateDate").showPicker?.()
                            }
                          />
                        </i>
                      </div>
                    </div>
                  </Grid>

                  {/* Expiry Date */}
                  <Grid item container xs={12} sm={6} md={6}>
                    <Grid item xs={12}>
                      <div className="input-wrapper">
                        <label htmlFor="expiryDate" className="required-label date-label">
                          Expiry Date
                        </label>
                        <div className="date-input-container" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                          <input
                            type="date"
                            className="form-control"
                            id="expiryDate"
                            name="expiryDate"
                            max="2050-01-01"
                            style={{ paddingRight: '2.5rem' }}
                          />
                          <i
                            style={{
                              position: 'absolute',
                              right: '0.75rem',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          >
                            <CalendarIcon
                              onClick={() =>
                                document.getElementById("expiryDate").showPicker?.()
                              }
                            />
                          </i>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  {/* Estimate Number */}
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="estimateNumber" className="required-label">
                        Estimate Number{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="estimateNumber"
                        name="estimateNumber"
                        required
                        readOnly
                        // style={{ border: '1px solid #ccc' }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>

          <Card
            sx={{
              borderRadius: "8px",
              marginBottom: "25px",
              padding: "15px",
              margin: "5px 10px",
              boxShadow: "0px 2px 4px rgba(0,0,0,0.05)"
            }}
          >
            {itemsList.map((item, index) => (
              <Grid
                container
                spacing={2}
                key={index}
                sx={{
                  mb: 1,
                  p: 2,
                  borderRadius: "8px",
                  backgroundColor: "#E9F5FE", // Restoring the light blue background requested earlier
                  alignItems: "center"
                }}
              >
                {/* Category Selection */}
                <Grid item xs={12} sm={6} md={2}>
                  <RadioGroup
                    row
                    value={item.category || "services"}
                    onChange={(e) => handleItemChange(index, "category", e.target.value)}
                  >
                    <FormControlLabel value="services" control={<Radio size="small" />} label="Services" />
                    <FormControlLabel value="products" control={<Radio size="small" />} label="Products" />
                  </RadioGroup>
                </Grid>

                {/* Item Selection */}
                <Grid item xs={12} sm={6} md={3}>
                  <select
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                    value={item.items}
                    onChange={(e) => {
                      handleItemChange(index, "items", e.target.value);
                    }}
                  >
                    <option value="">Select Item</option>
                    {(item.category === "products" ? productsList : servicesList).map((option) => (
                      <option
                        key={option.medical_service_id || option.product_id}
                        value={option.medical_service_id || option.product_id}
                      >
                        {option.name}
                      </option>
                    ))}
                  </select>
                </Grid>

                {/* Quantity Field */}
                <Grid item xs={12} sm={4} md={2}>
                  <input
                    type="number"
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                    placeholder="Enter quantity"
                    value={item.quantity}
                    onChange={(e) =>
                      handleItemChange(index, "quantity", e.target.value)
                    }
                    min="0"
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "+") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Grid>

                {/* Price Field */}
                <Grid item xs={12} sm={4} md={2}>
                  <input
                    type="text"
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                    value={item.price}
                    readOnly
                    placeholder="Price"
                  />
                </Grid>

                {/* Amount Field */}
                <Grid item xs={12} sm={4} md={2}>
                  <input
                    type="text"
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                    value={item.amount}
                    readOnly
                    placeholder="Amount"
                  />
                </Grid>

                {/* Action Field */}
                <Grid item xs={12} sm={12} md={1}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#bdbdbd",
                      color: "white",
                      minWidth: "80px",
                      padding: "6px 12px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      "&:hover": { backgroundColor: "#9e9e9e" }
                    }}
                    onClick={() => handleRemoveItem(index)}
                  >
                    REMOVE
                  </Button>
                </Grid>
              </Grid>
            ))}

            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
              style={{ outline: 'none !important', border: 'none !important' }}
            >
              <Grid item xs={12}>
                <center>
                  <button
                    // variant="contained"
                    // size="medium"
                    type="button"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    onClick={handleAddItem}
                    style={{
                      color: "white",
                      padding: "8px 16px",
                      width: "25%",
                      // transition: "background-color 0.3s ease",
                      backgroundColor: "#125386",
                      borderRadius: "10px",
                      // boxShadow: "0px 4px 4px 0px #00000040 inset"
                    }}
                  // startIcon={<AddIcon />}
                  >
                    + ADD
                  </button>
                </center>
              </Grid>
            </Grid>
          </Card>
          <Card
            sx={{
              // boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
              borderRadius: "8px",
              marginBottom: "25px",
              padding: "5px 10px",
              margin: "5px 10px",
            }}
          >
            {/* <div className="contact-panel">
              <div style={{ outline: 'none', border: 'none' }}> */}
            <Grid container spacing={2}
              alignItems="center"
              justifyContent="center"
              style={{ outline: 'none', border: 'none', boxShadow: 'none' }}>
              {/* Notes Section */}
              <Grid item xs={12} sm={6}>
                <div style={{ maxWidth: '100%', flexGrow: 1 }}>
                  {/* <label htmlFor="notes">Notes</label> */}
                  <textarea
                    id="notes"
                    name="notes"
                    placeholder="Notes"
                    value={notes}
                    onChange={(e) => handleNotesChange(e.target.value)}
                    style={{
                      width: "100%",
                      height: "247.5px",
                      borderRadius: "2%",
                      // boxShadow: "0px -3px 4px 0px #00000040 inset",
                      padding: "12px 16px"
                    }}
                    className="responsive-textarea"
                  />
                </div>
              </Grid>

              {/* Total Section */}
              <Grid item xs={12} sm={5} md={5} lg={4} style={{ marginLeft: "auto" }}>
                {/* <div className="card" style={{ padding: "30px", borderRadius: "10px" }}> */}
                {/* <div className="total-section"> */}
                <Grid container>
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="discount" style={{ color: "#808285" }}>Discount(%)</label>
                      <input
                        type="number"
                        className="form-control"
                        id="discount"
                        name="discount"
                        value={discount}
                        min="0"
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) =>
                          handleTotalChange("discount", e.target.value)
                        }
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>
                  {/* Tax field */}
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="tax" style={{ color: "#808285" }}>Add Tax(%)</label>
                      <input
                        type="number"
                        className="form-control"
                        id="tax"
                        name="tax"
                        value={tax}
                        onChange={(e) => handleTotalChange("tax", e.target.value)}
                        min="0"
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="totalAmount" style={{ color: "#808285" }}>TOTAL AMOUNT(Rs)</label>
                      <input
                        type="text"
                        className="form-control"
                        id="totalAmount"
                        name="totalAmount"
                        value={calculatedTotal}
                        readOnly
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>
                </Grid>
                {/* </div> */}
                {/* </div> */}
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
              style={{ marginTop: "5px", marginBottom: "5px" }}
            >
              <Grid item xs={6}>
                <center>
                  <button
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    type="submit"
                    style={{
                      color: "white",
                      padding: "8px 16px",
                      width: "50%",
                      // transition: "background-color 0.3s ease",
                      backgroundColor: "#125386",
                      borderRadius: "10px",
                      // boxShadow: "0px 4px 4px 0px #00000040 inset"
                    }}
                  >
                    SUBMIT
                  </button>
                </center>
              </Grid>
              <Grid item xs={6}>
                <center>
                  <button
                    type="button"
                    onClick={handleGoBack}
                    // variant="contained"
                    // size="medium"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      color: "white",
                      padding: "8px 16px",
                      width: "50%",
                      // transition: "background-color 0.3s ease",
                      backgroundColor: "#125386",
                      borderRadius: "10px",
                      // boxShadow: "0px 4px 4px 0px #00000040 inset"
                    }}
                  >
                    CANCEL
                  </button></center>
              </Grid>
            </Grid>

            {/* </div>
            </div> */}
          </Card>
        </form>
      </SideNavbar>
    </>
  );
};

export default EditEstimate;
